import { Component, OnInit, Inject, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { DatePipe, Location } from '@angular/common';
import { LeadTansactionInfo } from '../model/leadtansaction.model';
import { CompanyGroupInfo } from '../model/CompanyGroupInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { CompanyContactInfo } from '../model/CompanyContactInfo.model';
import { Subscription } from 'rxjs'; // Import Subscription

@Component({
  selector: 'app-projectsale-information',
  templateUrl: './projectsale-information.component.html',
  styleUrls: ['./projectsale-information.component.css']
})
export class ProjectsaleInformationComponent implements OnInit {
  baseurl: string;
  expense_baseurl: string;
  form: FormGroup;
  isOnUpdate: boolean = false;
  isViewOnly: boolean = false;
  isSubmitted: any;
  ProjectSaleList: ProjectSaleInfo[] = []
  hidProjectSaleId: number;
  hidProjectSaleState: string;
  hidProjectSubState: string;
  hidProjectRequestType: string;

  // Lead Transaction properties
  LeadTransaction: LeadTansactionInfo[] = [];
  totalLeadTransaction: number;
  totalPages_LeadTransac: number;
  currentPageNumber_LeadTransac: number = 1;

  // array control
  itemsSupport: FormArray;
  CompanyList: CompanyInfo[] = []
  CompanyGroupList: CompanyGroupInfo[] = [];
  StatusList: LookupInfo[] = []
  ProjectSaleTypeList: LookupInfo[] = [];
  CategoryList: LookupInfo[] = []
  ProjectSalePhaseList: LookupInfo[] = []
  ProjectSaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  monthNameslist: any;
  yearlist: any[];
  pastYearList: any[] = [];
  ProjectSaleContactPersonList: EmpInfo[];
  ProjectSaleCustomerTypeList: LookupInfo[] = [];
  SaleTeamOriginatorList: SaleTeamMappingEmployeeInfo[] = []
  AssetTypeList: AssetTypeInfo[] = []
  AssetCategoryList: AssetCategoryInfoInfo[] = []; //
  CompanyContactList: CompanyContactInfo[] = [];

  filteredCompanyGroupList: CompanyGroupInfo[] = [];
  searchText: string = '';
  showDropdown: boolean = false;

  filteredCompanyList: CompanyInfo[] = [];
  searchCompanyNameText: string = '';
  showCompanyDropdown: boolean = false;

  //Modal
  titlemodal: string;
  detailmodal: string;

  //Parameter
  _ParamStatus: string;
  _ParamProjectSaleId: number;
  _ParamOrigin: string;

  // Add new properties
  ChannelTypeList: any[] = [];
  ChannelMappingDList: any[] = [];
  ChannelMappingCList: any[] = [];
  isDealerChannel: boolean = false;
  environment: number = 10;
  currentPageNumber: number = 1;

  groupCodeSelected: string | null = null; // GroupCode is data from CompanyGroupCode ddl and send value to bind the ddl CompanyID
  IsShowOriginator: boolean = false; // Show Control select the Originator Emp when Set it true
  isShowOriginatorButtons: boolean = false;
  isShowOriginatorButtonsEdit: boolean = false;

  IsShowRenewalCase: boolean = false;

  private subscriptions: Subscription = new Subscription();

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router, private activatedRoute: ActivatedRoute, private location: Location) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    this._ParamStatus = this.activatedRoute.snapshot.params.status;
    this._ParamProjectSaleId = parseInt(this.activatedRoute.snapshot.params.id);
    this._ParamOrigin = this.activatedRoute.snapshot.params.origin;
  }

  async ngOnInit() {
  this.form = this.formBuilder.group({
    ProjectGroupMapping: [null],
    ProjectSaleCode: [null],
    ProjectSaleName: [null, Validators.required],
    ProjectSaleCompanyId: [null, Validators.required],
    ProjectSaleCompanyAbbreviation: [null],
    ProjectSaleStatus: [56],
    ProjectSaleType: [null],
    ProjectSaleCategory: [null],
    ProjectSaleTool: [null],
    ProjectSalePhase: [null],
    ProjectSaleBudget: [null],
    ProjectSaleEstimatePrice: [null, Validators.required],
    ProjectSaleExpectedClosePeriodMonth: [null],
    ProjectSaleExpectedClosePerioddYear: [null],
    ProjectSaleContactDate: [null, Validators.required],
    ProjectSaleCustomerType: [null, Validators.required],
    ProjectSaleContactPerson: [null, Validators.required],
    ProjectSaleContactEmail: [null],
    ProjectSaleContactTel: [null, Validators.required],
    arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
    ProjectSaleRemark: [null],
    ProjectSaleYear: [null, Validators.required],
    ProjectSaleContactPersonPosition: [null],
    EmpCodeSearch: [null],
    EmpNameSearch: [null],
    ProjectSaleTeamCode: [null, Validators.required],
    ProjectSaleChannelTypeCode: [null],
    ProjectSaleChannelMappingCode: [null],
    ProjectSaleCompanyGroupCode: [null, Validators.required],
    ProjectSaleOriginatorCode: [null],
    ProjectSaleAssetType: [null],
    ProjectSaleProductCategoryCode: [null, Validators.required],
    SelectCompanyContact: [null],
    ProjectSaleDeliveryEsitmateDate: [null],
    ProjectSaleFlagContractRenewal: [null]
  }, {
    validator: [
      this.channelMappingValidator,
      this.projectSaleProductCategoryCodeValidator
    ]
  });

  this.form.get('ProjectSaleTeamCode')?.valueChanges.subscribe((selectedCode) => {
    const selectedTeam = this.ProjectSaleTeamList.find(x => x.SaleTeamCode === selectedCode);
    this.IsShowOriginator = selectedTeam?.FlagIsOriginator === 'Y';

    if (this.IsShowOriginator === true) {
      this.loadSaleRequesterFromOriginatorEnable(auth_token).then((data) => { 
        this.SaleTeamOriginatorList = data; 
      });
    } else {
      this.form.patchValue({ ProjectSaleOriginatorCode: null });
      this.SaleTeamOriginatorList = [];
      this.isShowOriginatorButtons = false;
    }
  });

  this.form.get('ProjectSaleOriginatorCode')?.valueChanges.subscribe(val => {
    this.isShowOriginatorButtons = !!val;
    this.isShowOriginatorButtonsEdit = !!val;

    if (this.isShowOriginatorButtons == true && this.form.get('ProjectSaleFlagContractRenewal').value === true){
      this.IsShowRenewalCase = true;
      //console.log('isShowOriginatorButtons', this.isShowOriginatorButtons);
      //console.log('IsShowRenewalCase', this.IsShowRenewalCase);
    } else {
      this.IsShowRenewalCase = false;
      //console.log('isShowOriginatorButtons', this.isShowOriginatorButtons);
      //console.log('IsShowRenewalCase', this.IsShowRenewalCase);
    }

    //console.log('isShowOriginatorButtons', this.isShowOriginatorButtons)
  });

  this.form.get('ProjectSaleFlagContractRenewal')?.valueChanges.subscribe(val => {
      const result = val === true || val === 'Y' ? 'Y' : 'N';
      //console.log('Checkbox is now:', result); //

      if (this.isShowOriginatorButtons === true && result === 'Y') {
        this.IsShowRenewalCase = true;
        //console.log('isShowOriginatorButtons', this.isShowOriginatorButtons);
        //console.log('IsShowRenewalCase', this.IsShowRenewalCase);
      } else {
        this.IsShowRenewalCase = false;
        //console.log('isShowOriginatorButtons', this.isShowOriginatorButtons);
        //console.log('IsShowRenewalCase', this.IsShowRenewalCase);
      }
    });

  await this.loadEmp();

  var auth_token = await this.TokenService.RefreshToken();
  if (!!auth_token) {
    
    // โหลด CompanyGroup ก่อน (แต่ไม่ set ค่าเริ่มต้นที่นี่)
    await this.loadCompanyGroup(auth_token).then((data) => {
      this.CompanyGroupList = data;
      this.filteredCompanyGroupList = [...this.CompanyGroupList];
    });

    // โหลดข้อมูลต่างๆ ที่จำเป็น
    await this.loadLookupData(auth_token);
    
    // ตรวจสอบว่าเป็นโหมดไหน
    const isUpdateOrViewMode = this._ParamStatus == 'u' || this._ParamStatus == 'v';
    
    if (isUpdateOrViewMode) {
      // โหมด Update/View - โหลดข้อมูลที่มีอยู่
      if (this._ParamStatus == 'u') {
        this.isOnUpdate = true;
        this.isViewOnly = false;
      } else if (this._ParamStatus == 'v') {
        this.isOnUpdate = false;
        this.isViewOnly = true;
      }

      // โหลดข้อมูล ProjectSale ตาม ID
      await this.LoadProjectSaleList(auth_token);
      
      // หลังจากโหลดข้อมูลแล้ว ให้ set searchText และ searchCompanyNameText
      await this.setSearchTextFromLoadedData();
      
    } else {
      // โหมด Create - ใช้ค่าเริ่มต้น
      await this.setDefaultValues(auth_token);
    }

    console.log('isOnUpdate: ', this.isOnUpdate);
  }

  this.monthNameslist = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

  this.yearlist = this.generateArrayOfYears();
  this.pastYearList = this.generateArrayOfPastYears(10);

  this.subscriptions.add(
      this.form.get('SelectCompanyContact')?.valueChanges.subscribe(newValue => {
        console.log('Select value have changed (via valueChanges!!):', newValue);
        
        const selectedContactObject = this.CompanyContactList.find(
          contact => contact.CompanyContactCode === newValue
        );

        if (selectedContactObject) {
          console.log('Found selected CompanyContact object:', selectedContactObject);

          this.form.get('ProjectSaleContactPerson')?.setValue(selectedContactObject.CompanyContactName);
          this.form.get('ProjectSaleContactTel')?.setValue(selectedContactObject.CompanyContactTel);
          this.form.get('ProjectSaleContactEmail')?.setValue(selectedContactObject.CompanyContactEmail);

        } else {
          console.log('No CompanyContact object found for code:', newValue);
          this.form.get('ProjectSaleContactPerson')?.setValue(null);
          this.form.get('ProjectSaleContactTel')?.setValue(null);
          this.form.get('ProjectSaleContactEmail')?.setValue(null);
        }
      })
    );
}

  // Old Code and ref for new code //
  async ngOnInit0() { 

    this.form = this.formBuilder.group({
      ProjectGroupMapping: [null],
      ProjectSaleCode: [null],
      ProjectSaleName: [null, Validators.required],
      ProjectSaleCompanyId: [null, Validators.required],
      ProjectSaleCompanyAbbreviation: [null],
      ProjectSaleStatus: [56],
      ProjectSaleType: [null],
      ProjectSaleCategory: [null],
      ProjectSaleTool: [null],
      ProjectSalePhase: [null],
      ProjectSaleBudget: [null],
      ProjectSaleEstimatePrice: [null, Validators.required],
      ProjectSaleExpectedClosePeriodMonth: [null],
      ProjectSaleExpectedClosePerioddYear: [null],
      ProjectSaleContactDate: [null, Validators.required],
      ProjectSaleCustomerType: [null, Validators.required],
      ProjectSaleContactPerson: [null, Validators.required],
      ProjectSaleContactEmail: [null],
      ProjectSaleContactTel: [null, Validators.required],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      ProjectSaleRemark: [null],
      ProjectSaleYear: [null, Validators.required],
      ProjectSaleContactPersonPosition: [null],
      EmpCodeSearch: [null],
      EmpNameSearch: [null],
      ProjectSaleTeamCode: [null, Validators.required],
      ProjectSaleChannelTypeCode: [null],
      ProjectSaleChannelMappingCode: [null],
      ProjectSaleCompanyGroupCode: [null, Validators.required],
      ProjectSaleOriginatorCode: [null],
      ProjectSaleAssetType: [null],
      ProjectSaleProductCategoryCode: [null, Validators.required]
    },
      {
        validator: [
          this.channelMappingValidator,
          this.projectSaleProductCategoryCodeValidator
        ]
      },
    );

    this.form.get('ProjectSaleTeamCode')?.valueChanges.subscribe(
      (selectedCode) => {
        const selectedTeam = this.ProjectSaleTeamList.find(x => x.SaleTeamCode === selectedCode);
        this.IsShowOriginator = selectedTeam?.FlagIsOriginator === 'Y';

        if (this.IsShowOriginator === true) {
          this.loadSaleRequesterFromOriginatorEnable(auth_token).then((data) => { this.SaleTeamOriginatorList = data; });
        } else {
          this.form.patchValue({ ProjectSaleOriginatorCode: null });
          this.SaleTeamOriginatorList = [];
          this.isShowOriginatorButtons = false;
        }
      });

    this.form.get('ProjectSaleOriginatorCode')?.valueChanges.subscribe(val => {
      this.isShowOriginatorButtons = !!val; // มีค่าจะเป็น true, ไม่มีค่าจะเป็น false
      this.isShowOriginatorButtonsEdit = !!val;
    });

    this.form.get('ProjectSaleFlagContractRenewal')?.valueChanges.subscribe(val => {
      const result = val === true || val === 'Y' ? 'Y' : 'N';
      console.log('Checkbox is now:', result); //

      if (this.isShowOriginatorButtons === true && result === 'Y') {
        console.log('Case FlagContractRenewal == true')
      } else {
        console.log('Case FlagContractRenewal == false')
      }
    });

    await this.loadEmp();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.loadCompany(auth_token).then((data) => {
      //  this.CompanyList = data;
      //});
      this.loadCompanyGroup(auth_token).then((data) => {
      this.CompanyGroupList = data;
      this.filteredCompanyGroupList = [...this.CompanyGroupList];

      // ✅ เช็คว่าเป็นโหมด Create หรือไม่ ถึงจะ set ค่าเริ่มต้น
      const isCreateMode = this._ParamStatus !== 'u' && this._ParamStatus !== 'v';
      
      if (isCreateMode && this.CompanyGroupList.length > 0) {
        this.form.controls['ProjectSaleCompanyGroupCode'].setValue(this.CompanyGroupList[0].CompanyGroupCode);
        this.ProjectSaleCompGroupChange();

        const initialCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
        if (initialCode) {
          const selectedGroup = this.CompanyGroupList.find(x => x.CompanyGroupCode === initialCode);
          if (selectedGroup) {
            this.searchText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
          }
        }
      }
    });

      // **(เพิ่มใหม่)** Logic สำหรับ Company Name Autocomplete
      // เราจะโหลด CompanyList ที่นี่ และตั้งค่า filteredCompanyList
      // การโหลด CompanyList จะขึ้นอยู่กับ CompanyGroupCode ที่ถูกเลือก
      const isCreateMode = this._ParamStatus !== 'u' && this._ParamStatus !== 'v';
    if (isCreateMode) {
      const initialCompanyGroupCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
      if (initialCompanyGroupCode) {
        await this.loadCompany(auth_token, initialCompanyGroupCode).then((data) => {
          this.CompanyList = data;
          this.filteredCompanyList = [...this.CompanyList];
        });
      }
    }

      this.loadLookup('PROJECTSALESTATUS', auth_token).then((data) => {
        this.StatusList = data;
      });

      this.loadLookup('PROJECTSALETYPE', auth_token).then((data) => {
        this.ProjectSaleTypeList = data;
        this.form.get('ProjectSaleType')?.setValue(this.ProjectSaleTypeList[0].Id);
      });

      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });

      this.loadLookup('PROJECTSALEPHASE', auth_token).then((data) => {
        this.ProjectSalePhaseList = data;
        console.log('PROJECTSALEPHASE data', data);
        this.form.get('ProjectSalePhase')?.setValue(this.ProjectSalePhaseList[0].Id);
      });

      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        this.ProjectSaleCustomerTypeList = data;

        if (this.ProjectSaleCustomerTypeList.length > 0) {
          this.form.controls['ProjectSaleCustomerType'].setValue(this.ProjectSaleCustomerTypeList[0].Id);
        }
      });

      this.loadSaleTeamMappingEmployee(auth_token).then((data) => {
        this.ProjectSaleTeamList = data;

        console.log('ProjectSaleTeamList', this.ProjectSaleTeamList);

        if (this.ProjectSaleTeamList.length > 0) {
          this.form.controls['ProjectSaleTeamCode'].setValue(this.ProjectSaleTeamList[0].SaleTeamCode);
          this.IsShowOriginator = (this.ProjectSaleTeamList[0].FlagIsOriginator === 'Y');

          console.log('IsShowOriginatorFlag', this.IsShowOriginator);

          this.loadSaleRequesterFromOriginatorEnable(auth_token).then((data) => {
            this.SaleTeamOriginatorList = data;
          });
        }
        //console.log(data)
      });

      await this.loadAssetCategoryList(auth_token).then((data) => {
        this.AssetCategoryList = data;

        if (this.AssetCategoryList.length > 0) {
          this.form.patchValue({ ProjectSaleProductCategoryCode: this.AssetCategoryList[0].AssetCategoryCode });
          this.onProductCategoryChange({ target: { value: this.AssetCategoryList[0].AssetCategoryCode } });
        }

      });

      // this.loadAssetTypeList(auth_token).then((data) => {
      //   this.AssetTypeList = data;
      // });

      // Load channel type data
      await this.loadChannelTypes(auth_token);

      // Load channel mapping data
      await this.loadChannelMapping(auth_token, 'D');
      await this.loadChannelMapping(auth_token, 'C');

      if (this._ParamStatus == 'u' || this._ParamStatus == 'v') {
        if (this._ParamStatus == 'u') {
          this.isOnUpdate = true
          this.isViewOnly = false;
        } else if (this._ParamStatus == 'v') {
          this.isOnUpdate = false;
          this.isViewOnly = true;
        }
        await this.LoadProjectSaleList(auth_token);

        const updatedCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
      if (updatedCode) {
        const selectedGroup = this.CompanyGroupList.find(x => x.CompanyGroupCode === updatedCode);
        if (selectedGroup) {
          this.searchText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
        }
        
        // ✅ โหลด Company data และ set searchCompanyNameText สำหรับโหมด update/view
        await this.loadCompany(auth_token, updatedCode).then((data) => {
          this.CompanyList = data;
          this.filteredCompanyList = [...this.CompanyList];
          
          const updatedCompanyId = this.form.get('ProjectSaleCompanyId')?.value;
          if (updatedCompanyId) {
            const selectedCompany = this.CompanyList.find(x => x.CompanyId === updatedCompanyId);
            if (selectedCompany) {
              this.searchCompanyNameText = `${selectedCompany.CompanyGroupCode} - ${selectedCompany.CompanyCode} - ${selectedCompany.CompanyName}`;
            }
          }
        });
      } 

        console.log('isOnUpdate: ', this.isOnUpdate);

      }

    }

    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    this.yearlist = this.generateArrayOfYears();
    this.pastYearList = this.generateArrayOfPastYears(10);


  }
  // Old Code and ref for new code //

  // ngOninit separate method for lookup data part
  private async loadLookupData(auth_token: string) {
    // Load Status
    this.loadLookup('PROJECTSALESTATUS', auth_token).then((data) => {
    this.StatusList = data;
  });

  // Load Project Sale Type
  this.loadLookup('PROJECTSALETYPE', auth_token).then((data) => {
    this.ProjectSaleTypeList = data;
  });

  // Load Category
  this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
    this.CategoryList = data;
  });

  // Load Phase
  this.loadLookup('PROJECTSALEPHASE', auth_token).then((data) => {
    this.ProjectSalePhaseList = data;
    console.log('PROJECTSALEPHASE data', data);
  });

  // Load Customer Type
  this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
    this.ProjectSaleCustomerTypeList = data;
  });

  // Load Sale Team
  this.loadSaleTeamMappingEmployee(auth_token).then((data) => {
    this.ProjectSaleTeamList = data;
    console.log('ProjectSaleTeamList', this.ProjectSaleTeamList);
  });

  // Load Asset Category
  await this.loadAssetCategoryList(auth_token).then((data) => {
    this.AssetCategoryList = data;
  });

  // Load channel type and mapping data
  await this.loadChannelTypes(auth_token);
  await this.loadChannelMapping(auth_token, 'D');
  await this.loadChannelMapping(auth_token, 'C');
  }

  // Method separate set AutoComplete Create Part
  private async setDefaultValues(auth_token: string) {
    // Set default CompanyGroup (ใช้ index แรก)
    if (this.CompanyGroupList.length > 0) {
      this.form.controls['ProjectSaleCompanyGroupCode'].setValue(this.CompanyGroupList[0].CompanyGroupCode);
      this.ProjectSaleCompGroupChange();

      const initialCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
      if (initialCode) {
        const selectedGroup = this.CompanyGroupList.find(x => x.CompanyGroupCode === initialCode);
      if (selectedGroup) {
        this.searchText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
      }
    }
  }

  // Set default ProjectSaleType
  if (this.ProjectSaleTypeList.length > 0) {
    this.form.get('ProjectSaleType')?.setValue(this.ProjectSaleTypeList[0].Id);
  }

  // Set default ProjectSalePhase
  if (this.ProjectSalePhaseList.length > 0) {
    this.form.get('ProjectSalePhase')?.setValue(this.ProjectSalePhaseList[0].Id);
  }

  // Set default CustomerType
  if (this.ProjectSaleCustomerTypeList.length > 0) {
    this.form.controls['ProjectSaleCustomerType'].setValue(this.ProjectSaleCustomerTypeList[0].Id);
  }

  // Set default SaleTeam
  if (this.ProjectSaleTeamList.length > 0) {
    this.form.controls['ProjectSaleTeamCode'].setValue(this.ProjectSaleTeamList[0].SaleTeamCode);
    this.IsShowOriginator = (this.ProjectSaleTeamList[0].FlagIsOriginator === 'Y');
    
    console.log('IsShowOriginatorFlag', this.IsShowOriginator);
    
    this.loadSaleRequesterFromOriginatorEnable(auth_token).then((data) => {
      this.SaleTeamOriginatorList = data;
    });
  }

  // Set default AssetCategory
  if (this.AssetCategoryList.length > 0) {
    this.form.patchValue({ ProjectSaleProductCategoryCode: this.AssetCategoryList[0].AssetCategoryCode });
    this.onProductCategoryChange({ target: { value: this.AssetCategoryList[0].AssetCategoryCode } });
  }

  // Load initial Company data based on selected CompanyGroup
  const initialCompanyGroupCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
  if (initialCompanyGroupCode) {
    await this.loadCompany(auth_token, initialCompanyGroupCode).then((data) => {
      this.CompanyList = data;
      this.filteredCompanyList = [...this.CompanyList];
    });
  }
}

  // Method Separate set searchText after load data from Update/View
  private async setSearchTextFromLoadedData() {
    // Set searchText สำหรับ CompanyGroup
    const loadedCompanyGroupCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;
    if (loadedCompanyGroupCode) {
      const selectedGroup = this.CompanyGroupList.find(x => x.CompanyGroupCode === loadedCompanyGroupCode);
    if (selectedGroup) {
      this.searchText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
    }
    
    // โหลด Company data ตาม CompanyGroup ที่โหลดมา
    const auth_token = await this.TokenService.RefreshToken();
    await this.loadCompany(auth_token, loadedCompanyGroupCode).then((data) => {
      this.CompanyList = data;
      this.filteredCompanyList = [...this.CompanyList];
      
      // Set searchCompanyNameText สำหรับ Company
      const loadedCompanyId = this.form.get('ProjectSaleCompanyId')?.value;
      if (loadedCompanyId) {
        const selectedCompany = this.CompanyList.find(x => x.CompanyId === loadedCompanyId);
          if (selectedCompany) {
            this.searchCompanyNameText = `${selectedCompany.CompanyGroupCode} - ${selectedCompany.CompanyCode} - ${selectedCompany.CompanyName}`;
          }
        }
      });
    }
  }
  async btnClick_submitUpdateProjectSale(id, saveType) {


    if (saveType == '1-1') {

      // Check only these three fields
      let isValid = true;

      // Check ProjectSaleName
      if (!this.form.get('ProjectSaleName').value) {
        this.form.get('ProjectSaleName').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleCompanyId
      if (!this.form.get('ProjectSaleCompanyId').value) {
        this.form.get('ProjectSaleCompanyId').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleCompanyGroupCode
      if (!this.form.get('ProjectSaleCompanyGroupCode').value) {
        this.form.get('ProjectSaleCompanyGroupCode').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleYear
      if (!this.form.get('ProjectSaleYear').value) {
        this.form.get('ProjectSaleYear').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleTeamCode
      if (!this.form.get('ProjectSaleTeamCode').value) {
        this.form.get('ProjectSaleTeamCode').markAsTouched();
        isValid = false;
      }

      // If any of the three fields is invalid, focus on the first one and return
      if (!isValid) {
        if (!this.form.get('ProjectSaleName').value) {
          $('#ProjectSaleName').focus();
        } else if (!this.form.get('ProjectSaleCompanyId').value) {
          $('#ProjectSaleCompanyId').focus();
        } else if (!this.form.get('ProjectSaleCompanyGroupCode').value) {
          $('#ProjectSaleCompanyGroupCode').focus();
        } else if (!this.form.get('ProjectSaleYear').value) {
          $('#ProjectSaleYear').focus();
        } else if (!this.form.get('ProjectSaleTeamCode').value) {
          $('#ProjectSaleTeamCode').focus();
        }
        return;
      }

    }


    if (this.form.valid || saveType == '1-1') {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnCreating('y');
        id = this.hidProjectSaleId

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        console.log('savetype', saveType);

        var objectjson = {};
        objectjson['ProjectSaleId'] = id;
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        //objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyAbbreviation'].value);
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleEstimatePrice'] = this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;
        objectjson['ProjectSaleState'] = saveType;
        objectjson['ProjectSaleSubState'] = this.hidProjectSubState;
        objectjson['ProjectSaleContactPersonPosition'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPersonPosition'].value);
        objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleTeamCode'].value);
        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);
        objectjson['ProjectSaleCompanyGroupCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyGroupCode'].value);
        objectjson['ProjectSaleAssetTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleAssetType'].value);
        objectjson['ProjectSaleAssetCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleProductCategoryCode'].value);
        objectjson['flagupdatefromCreateLead'] = "Y"; // ใช้เพื่อบอกว่าเป็นการอัพเดตจาก Create Lead เท่านั้น
        objectjson['ProjectSaleDeliveryEsitmateDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleDeliveryEsitmateDate'].value);
        
        const rawValue = this.form.controls['ProjectSaleFlagContractRenewal'].value;
        const ynValue = rawValue === true || rawValue === 'Y' ? 'Y' : 'N';
        objectjson['ProjectSaleFlagContractRenewal'] = this.checkUndefinedString(ynValue);

        //objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);

        if (saveType === "1-0") {
          objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) : null;
        } 
        else {
          objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          //objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);
        }

        if (saveType === "1-2") {
          objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) : null;
        } 

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnCreating('n');
            this.titlemodal = 'Update fail.';
            this.detailmodal = 'Your lead was Update fail.';
            $('#ModalError').modal();
          },
            async () => {
              console.log("Update = " + this.isSubmitted);
              this.OnCreating('n');


              // ยังไม่ใช้งาน
              ////also save to expense
              //this.expenseclaims_submitUpdateProjectSale(id, saveType);

              this.titlemodal = 'Successfully';
              if (saveType == '1-1') {
                this.detailmodal = 'You lead was save change successfully.';
              } else if (saveType == '1-2') {
                this.detailmodal = 'You lead was submit successfully.';
              }
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').removeClass().addClass('modal-header bg-gold');
              $('#ModalComplate').modal();

              setTimeout(() => {
                // Do something after 3 seconds
                this.router.navigateByUrl('/projectsale-management');
                if (this._ParamOrigin == 'worklist') {
                  this.router.navigateByUrl('/worklist-sale');
                }
              }, 3000);

            }
          )
      }

    } else {
      this.GlobalService.validateAllFormFields(this.form);
      $('input.ng-invalid')[0].focus()
    }

  }

  GoBack() {
    this.location.back()
  }

  async expenseclaims_submitUpdateProjectSale(id, saveType) {
    if (true) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        id = this.hidProjectSaleId

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = id;
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        //objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyAbbreviation'].value);
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleEstimatePrice'] = this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;
        objectjson['ProjectSaleState'] = saveType;
        objectjson['ProjectSaleContactPersonPosition'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPersonPosition'].value);
        objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleTeamCode'].value);
        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);
        objectjson['ProjectSaleCompanyGroupCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyGroupCode'].value);
        objectjson['ProjectSaleAssetCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleProductCategoryCode'].value);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.expense_baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update expense fail");
          },
            async () => {
              console.log("Update expense = " + this.isSubmitted); //
            }
          )
      }

    }

  }

  async LoadProjectSaleList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['ProjectSaleId'] = this._ParamProjectSaleId;

    let strjson = JSON.stringify(objectjson);

    await this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .subscribe({
        next: async (data) => {
          this.ProjectSaleList = data;

          if (this.ProjectSaleList.length) {
            let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleId == this._ParamProjectSaleId);

            // get json object from field SupportTeam
            this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
            this.itemsSupport.clear();
            var objectSupportTeamFromJson = [];
            if (this.ProjectSaleList[index].ProjectSaleSupportTeam != null && this.ProjectSaleList[index].ProjectSaleSupportTeam != '') {
              objectSupportTeamFromJson = JSON.parse(this.ProjectSaleList[index].ProjectSaleSupportTeam);
            }

            for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
              this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
            }

            var d = new Date();
            var monthindex = d.getMonth() + 1;
            var yearcurrent = d.getFullYear();

            this.form.patchValue({
              ProjectGroupMapping: this.ProjectSaleList[index].ProjectGroupMapping != null ? this.ProjectSaleList[index].ProjectGroupMapping : null,
              ProjectSaleCode: this.ProjectSaleList[index].ProjectSaleCode != null ? this.ProjectSaleList[index].ProjectSaleCode : null,
              ProjectSaleName: this.ProjectSaleList[index].ProjectSaleName != null ? this.ProjectSaleList[index].ProjectSaleName : null,
              ProjectSaleCompanyId: this.ProjectSaleList[index].ProjectSaleCompanyId != null ? this.ProjectSaleList[index].ProjectSaleCompanyId : null,
              ProjectSaleCompanyAbbreviation: this.ProjectSaleList[index].ProjectSaleCompanyAbbreviation != null ? this.ProjectSaleList[index].ProjectSaleCompanyAbbreviation : null,
              ProjectSaleStatus: this.ProjectSaleList[index].ProjectSaleStatus != null ? this.ProjectSaleList[index].ProjectSaleStatus : null,
              ProjectSaleType: this.ProjectSaleList[index].ProjectSaleType != null ? this.ProjectSaleList[index].ProjectSaleType : null,
              ProjectSaleCategory: this.ProjectSaleList[index].ProjectSaleCategoryCode != null ? this.ProjectSaleList[index].ProjectSaleCategoryCode : null,
              ProjectSaleTool: this.ProjectSaleList[index].ProjectSaleTool != null ? this.ProjectSaleList[index].ProjectSaleTool : null,
              ProjectSalePhase: this.ProjectSaleList[index].ProjectSalePhase != null ? this.ProjectSaleList[index].ProjectSalePhase : null,
              ProjectSaleBudget: this.ProjectSaleList[index].ProjectSaleBudget != null ? this.numberWithCommas(this.ProjectSaleList[index].ProjectSaleBudget) : null,
              ProjectSaleEstimatePrice: this.ProjectSaleList[index].ProjectSaleEstimatePrice != null ? this.numberWithCommas(this.ProjectSaleList[index].ProjectSaleEstimatePrice) : null,
              ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth) : monthindex,
              ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[index].ProjectSaleClosedPeriodYear != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodYear) : yearcurrent,
              ProjectSaleContactDate: this.ProjectSaleList[index].ProjectSaleContactDate != null && this.ProjectSaleList[index].ProjectSaleContactDate != "" ? this.formatDate(this.ProjectSaleList[index].ProjectSaleContactDate) : null,
              ProjectSaleCustomerType: this.ProjectSaleList[index].ProjectSaleCustomerType != null ? parseInt(this.ProjectSaleList[index].ProjectSaleCustomerType) : null,
              ProjectSaleContactPerson: this.ProjectSaleList[index].ProjectSaleContactPerson != null ? this.ProjectSaleList[index].ProjectSaleContactPerson : null,
              ProjectSaleContactEmail: this.ProjectSaleList[index].ProjectSaleContactEmail != null ? this.ProjectSaleList[index].ProjectSaleContactEmail : null,
              ProjectSaleContactTel: this.ProjectSaleList[index].ProjectSaleContactTel != null ? this.ProjectSaleList[index].ProjectSaleContactTel : null,
              ProjectSaleRemark: null,//always null - tis.ProjectSaleList[index].ProjectSaleRemark != null ? this.ProjectSaleList[index].ProjectSaleRemark : null,
              ProjectSaleYear: this.ProjectSaleList[index].ProjectSaleYear != null ? parseInt(this.ProjectSaleList[index].ProjectSaleYear) : yearcurrent,
              ProjectSaleContactPersonPosition: this.ProjectSaleList[index].ProjectSaleContactPersonPosition,
              ProjectSaleTeamCode: this.ProjectSaleList[index].ProjectSaleTeamCode != null ? this.ProjectSaleList[index].ProjectSaleTeamCode : null,
              ProjectSaleChannelTypeCode: this.ProjectSaleList[index].ProjectSaleChannelTypeCode != null ? this.ProjectSaleList[index].ProjectSaleChannelTypeCode : null,
              ProjectSaleChannelMappingCode: this.ProjectSaleList[index].ProjectSaleChannelMappingCode != null ? this.ProjectSaleList[index].ProjectSaleChannelMappingCode : null,
              ProjectSaleCompanyGroupCode: this.ProjectSaleList[index].ProjectSaleCompanyGroupCode != null ? this.ProjectSaleList[index].ProjectSaleCompanyGroupCode : null,
              ProjectSaleOriginatorCode: this.ProjectSaleList[index].ProjectSaleOriginatortoRequester != null ? this.ProjectSaleList[index].ProjectSaleOriginatortoRequester : null,
              //ProjectSaleAssetType: this.ProjectSaleList[index].ProjectSaleAssetTypeCode != null ? this.ProjectSaleList[index].ProjectSaleAssetTypeCode : null,
              ProjectSaleProductCategoryCode: this.ProjectSaleList[index].ProjectSaleAssetCategoryCode && this.ProjectSaleList[index].ProjectSaleAssetCategoryCode !== "" ? this.ProjectSaleList[index].ProjectSaleAssetCategoryCode : null,
              ProjectSaleDeliveryEsitmateDate: this.ProjectSaleList[index].ProjectSaleDeliveryEsitmateDate != null && this.ProjectSaleList[index].ProjectSaleDeliveryEsitmateDate != "" ? this.formatDate(this.ProjectSaleList[index].ProjectSaleDeliveryEsitmateDate) : null,
              ProjectSaleFlagContractRenewal: this.ProjectSaleList[index].ProjectSaleFlagContractRenewal && this.ProjectSaleList[index].ProjectSaleFlagContractRenewal !== "" ? this.ProjectSaleList[index].ProjectSaleFlagContractRenewal === 'Y' : false,


            });

            // **(เพิ่มใหม่)** ตั้งค่า searchText สำหรับ Company Group Autocomplete
            const loadedCompanyGroupCode = this.ProjectSaleList[index].ProjectSaleCompanyGroupCode;
            if (loadedCompanyGroupCode) {
              // ค้นหา CompanyGroupInfo จาก CompanyGroupList ที่โหลดไว้แล้วใน ngOnInit
              const selectedGroup = this.CompanyGroupList.find(x => x.CompanyGroupCode === loadedCompanyGroupCode);
              if (selectedGroup) {
                this.searchText = `${selectedGroup.CompanyGroupCode} - ${selectedGroup.CompanyGroupName}`;
              }
            }

            if (this.isViewOnly) {
              this.AssetTypeList = []; // **สำคัญ**: เคลียร์ลิสต์ให้ว่างเปล่าเมื่อเป็นโหมดดูอย่างเดียว
            } else {
              // ถ้าไม่ใช่โหมดดูอย่างเดียว ค่อยโหลดและ patch ค่า
              await this.onLoadAssetTypeByCategory(this.ProjectSaleList[index].ProjectSaleAssetCategoryCode, this.ProjectSaleList[index].ProjectSaleAssetTypeCode);
              // Note: onLoadAssetTypeByCategory จะ patch ProjectSaleAssetType ให้เอง
            }

            await this.onLoadAssetTypeByCategory(this.ProjectSaleList[index].ProjectSaleAssetCategoryCode, this.ProjectSaleList[index].ProjectSaleAssetTypeCode);

            console.log('ProjectSaleOriginatorCode Value', this.form.get('ProjectSaleOriginatorCode')?.value); // value / null
            this.isShowOriginatorButtonsEdit = !!this.form.get('ProjectSaleOriginatorCode')?.value;

            //this.form.patchValue({
            //  ProjectSaleContactPersonPosition: $('#ProjectSaleContactPerson').find(":selected").attr('positionname') != null ? $('#ProjectSaleContactPerson').find(":selected").attr('positionname') : null,
            //});

            this.hidProjectSaleId = this.ProjectSaleList[index].ProjectSaleId
            this.hidProjectSaleState = this.ProjectSaleList[index].ProjectSaleState;
            this.hidProjectSubState = this.ProjectSaleList[index].ProjectSaleSubState;
            this.hidProjectRequestType = this.ProjectSaleList[index].ProjectSaleRequestTypeCode;

            const groupCode = this.ProjectSaleList[index].ProjectSaleCompanyGroupCode;
            const companyId = this.ProjectSaleList[index].ProjectSaleCompanyId;

            if (!!auth_token) {
              this.loadCompany(auth_token, groupCode).then((companyList) => {
                this.CompanyList = companyList;
                this.form.patchValue({ ProjectSaleCompanyId: companyId ?? null });

                const selectedCompany = this.CompanyList.find(x => x.CompanyId === companyId);
                if (selectedCompany) {
                  this.searchCompanyNameText = `${selectedCompany.CompanyGroupCode} - ${selectedCompany.CompanyCode} - ${selectedCompany.CompanyName}`;
                }
              });
            }

            console.log('hidProjectSaleState: ', this.hidProjectSaleState);
            // หลังจากคุณ set ค่าแล้ว
            this.form.patchValue({ ProjectSaleOriginatorCode: this.ProjectSaleList[index].ProjectSaleOriginatortoRequester });

            // Disable/Enable dropdown ตาม state
            if (this.hidProjectSaleState === '1-0' || this._ParamStatus === 'v') {
              this.form.controls['ProjectSaleOriginatorCode'].disable(); // <-- สำคัญ
            } else {
              this.form.controls['ProjectSaleOriginatorCode'].enable();
            }


            //load current transaction log list
            this.LoadTansaction(this.hidProjectRequestType, this.hidProjectSaleId).then((data) => {
              this.LeadTransaction = data;
            });

            this.LoadCountTansaction(this.hidProjectRequestType, this.hidProjectSaleId);

          }

        }
      });

    // Fix ส่วน Code ตอน edit แล้ว bind data formcontrol ProjectSaleChannelMappingCode ไม่ติด value
    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .toPromise()
      .then(data => {
        this.ProjectSaleList = data;

        if (this.ProjectSaleList.length) {
          const index = this.ProjectSaleList.findIndex(x => x.ProjectSaleId == this._ParamProjectSaleId);

          // patch ค่า ProjectSaleChannelTypeCode ก่อน และเคลียร์ ProjectSaleChannelMappingCode
          this.form.patchValue({
            ProjectSaleChannelTypeCode: this.ProjectSaleList[index].ProjectSaleChannelTypeCode ?? null,
            ProjectSaleChannelMappingCode: null,
          });

          // สร้าง fake event สำหรับเรียก onChannelTypeChange
          const fakeEvent = { target: { value: this.ProjectSaleList[index].ProjectSaleChannelTypeCode } };

          //console.log('Dropdown list after load:', this.ChannelMappingDList);

          // เรียก onChannelTypeChange แล้ว patch ค่า ProjectSaleChannelMappingCode หลังโหลด dropdown ลูกเสร็จ
          this.onChannelTypeChange(fakeEvent).then(() => {
            // ใช้ setTimeout เพื่อรอให้ Angular render dropdown เสร็จ
            setTimeout(() => {
              const code = this.ProjectSaleList[index].ProjectSaleChannelMappingCode ?? null;

              this.form.patchValue({
                ProjectSaleChannelMappingCode: code
              });
            }, 0);
          });

          this.form.patchValue({
            ProjectSaleProductCategoryCode: this.ProjectSaleList[index].ProjectSaleAssetCategoryCode ?? null,
            ProjectSaleAssetType: null,
          });

          const fakeEventProductCategoryCode = { target: { value: this.ProjectSaleList[index].ProjectSaleAssetCategoryCode } };

          this.onProductCategoryChange(fakeEventProductCategoryCode).then(() => {
            // ใช้ setTimeout เพื่อรอให้ Angular render dropdown เสร็จ
            setTimeout(() => {
              const codeofProjectSaleProductCategory = this.ProjectSaleList[index].ProjectSaleAssetCategoryCode ?? null;

              this.form.patchValue({
                ProjectSaleAssetCategoryCode: codeofProjectSaleProductCategory
              });
            }, 0);
          });
        }
      })
      .catch(err => {
        console.error('Error loading ProjectSale:', err);
      });

  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }


  async btnClick_submitInsertProjectSale(saveType) {

    console.log('updatestatus: ', this.isOnUpdate);

    if (saveType == '1-1') {

      // Check only these three fields
      let isValid = true;

      // Check ProjectSaleName
      if (!this.form.get('ProjectSaleName').value) {
        this.form.get('ProjectSaleName').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleCompanyId
      if (!this.form.get('ProjectSaleCompanyId').value) {
        this.form.get('ProjectSaleCompanyId').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleCompanyGroupCode
      if (!this.form.get('ProjectSaleCompanyGroupCode').value) {
        this.form.get('ProjectSaleCompanyGroupCode').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleYear
      if (!this.form.get('ProjectSaleYear').value) {
        this.form.get('ProjectSaleYear').markAsTouched();
        isValid = false;
      }

      // Check ProjectSaleTeamCode
      if (!this.form.get('ProjectSaleTeamCode').value) {
        this.form.get('ProjectSaleTeamCode').markAsTouched();
        isValid = false;
      }

      // If any of the three fields is invalid, focus on the first one and return
      if (!isValid) {
        if (!this.form.get('ProjectSaleName').value) {
          $('#ProjectSaleName').focus();
        } else if (!this.form.get('ProjectSaleCompanyId').value) {
          $('#ProjectSaleCompanyId').focus();
        } else if (!this.form.get('ProjectSaleCompanyGroupCode').value) {
          $('#ProjectSaleCompanyGroupCode').focus();
        } else if (!this.form.get('ProjectSaleYear').value) {
          $('#ProjectSaleYear').focus();
        } else if (!this.form.get('ProjectSaleTeamCode').value) {
          $('#ProjectSaleTeamCode').focus();
        }
        return;
      }

    }


    if (this.form.valid || saveType == '1-1') {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        console.log('form submitted');
        this.OnCreating('y');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroupMapping'] = this.checkUndefinedString(this.form.controls['ProjectGroupMapping'].value);
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        //objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyAbbreviation'].value);

        if (saveType === '1-1' || saveType === '1-2' || saveType === '1-0') {
          objectjson['ProjectSaleStatus'] = 56;
        } else {
          //console.log('saveType not 1-1/1-2 = ' + saveType);
        }

        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));

        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleEstimatePrice'] = this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);

        if (saveType === "1-0") {
          objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value) : null;
        } else if (saveType === "1-1"){
          objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);
          objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        }
        else {
          objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
          //objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);
        }

        if (saveType === "1-2") {
          objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);
        }

        objectjson['ProjectSaleRequestTypeCode'] = '1';
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;

        objectjson['ProjectSaleFlagDelete'] = "N";
        objectjson['ProjectSaleActiveFlag'] = "Y";
        objectjson['ProjectSaleState'] = saveType;

        objectjson['ProjectSaleContactPersonPosition'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPersonPosition'].value);
        objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleTeamCode'].value);

        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);
        objectjson['ProjectSaleCompanyGroupCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyGroupCode'].value);
        objectjson['ProjectSaleAssetTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleAssetType'].value);
        objectjson['ProjectSaleAssetCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleProductCategoryCode'].value); 
        objectjson['ProjectSaleDeliveryEsitmateDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleDeliveryEsitmateDate'].value);
        
        const rawValue = this.form.controls['ProjectSaleFlagContractRenewal'].value;
        const ynValue = rawValue === true || rawValue === 'Y' ? 'Y' : 'N';
        objectjson['ProjectSaleFlagContractRenewal'] = this.checkUndefinedString(ynValue);

        //objectjson['ProjectSaleOriginatortoRequester'] = this.checkUndefinedString(this.form.controls['ProjectSaleOriginatorCode'].value);        

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/InsertProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
            this.titlemodal = 'Insert fail.';
            this.detailmodal = 'Your lead was Insert fail.';
            $('#ModalError').modal();

          },
            async () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');

              // ยังไม่ใช้งาน
              ////also save to expense
              //this.expenseclaims_submitInsertProjectSale(saveType);

              this.titlemodal = 'Successfully';
              if (saveType == '1-1') {
                this.detailmodal = 'You lead was save draft successfully.';
              } else if (saveType == '1-2') {
                this.detailmodal = 'You lead was submit successfully.';
              }

              $('#ModalComplate').modal();

              setTimeout(() => {
                // Do something after 3 seconds
                this.router.navigateByUrl('/projectsale-management');
              }, 3000);
            }
          )

      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
      $('input.ng-invalid')[0].focus()
    }
  }

  async expenseclaims_submitInsertProjectSale(saveType) {
    if (true) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        console.log('form submitted');

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroupMapping'] = this.checkUndefinedString(this.form.controls['ProjectGroupMapping'].value);
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        //objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyAbbreviation'].value);
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));

        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleEstimatePrice'] = this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value) != "" ? this.numberRemoveCommas(this.checkUndefinedString(this.form.controls['ProjectSaleEstimatePrice'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleRequestTypeCode'] = '1';
        objectjson['ProjectSaleYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) ? this.checkUndefinedString(this.form.controls['ProjectSaleYear'].value) : null;

        objectjson['ProjectSaleFlagDelete'] = "N";
        objectjson['ProjectSaleActiveFlag'] = "Y";
        objectjson['ProjectSaleState'] = saveType;

        objectjson['ProjectSaleContactPersonPosition'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPersonPosition'].value);
        objectjson['ProjectSaleTeamCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleTeamCode'].value);

        objectjson['ProjectSaleChannelTypeCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelTypeCode'].value);
        objectjson['ProjectSaleChannelMappingCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleChannelMappingCode'].value);
        objectjson['ProjectSaleCompanyGroupCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyGroupCode'].value);
        objectjson['ProjectSaleAssetCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleProductCategoryCode'].value);

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.expense_baseurl + "ProjectSale/InsertProjectSale", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert expense fail")

          },
            async () => {
              console.log("Insert expense = " + this.isSubmitted)
            }
          )

      }
    }
  }

  async btnonclick_loadCategory() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });
    }
  }

  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }
  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $('.page-body *').attr("disabled", 'true');
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $('.page-body *').removeAttr("disabled");
    }

  }


  ProjectSaleContactPersonOnChange(traget) {
    this.form.patchValue({
      ProjectSaleContactPersonPosition: $(traget.currentTarget).find(":selected").attr('positionname') != null ? $(traget.currentTarget).find(":selected").attr('positionname') : null,
      ProjectSaleContactEmail: $(traget.currentTarget).find(":selected").attr('mail') != null ? $(traget.currentTarget).find(":selected").attr('mail') : null,
      ProjectSaleContactTel: $(traget.currentTarget).find(":selected").attr('mobile') != null ? $(traget.currentTarget).find(":selected").attr('mobile') : null,
    });

  }

  async loadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectSaleContactPersonList = data;
        });
    }
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years.reverse()
  }

  generateArrayOfPastYears(number) {
    var max = new Date().getFullYear()
    var min = max - number
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }


  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  async loadCompany(auth_token: string, groupCode: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    objectjson['CompanyGroupCode'] = this.checkUndefinedString(groupCode);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
      .toPromise()

  }

  async loadCompanyGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<CompanyGroupInfo[]>(this.baseurl + "Company/GetCompanyGroup", strjson, httpOptions)
      .toPromise()

  }

  async loadSaleTeamMappingEmployee(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    objectjson['EmployeeCode'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
      .toPromise()
  }

  async loadLookup(lookuptype: string, auth_token: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise()
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  async btnonclick_loadcompany() {
    if (!this.groupCodeSelected) {
      alert("Please select a Company Group first.");
      return;
    }

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token, this.groupCodeSelected).then((data) => {
        this.CompanyList = data;
      });
    }
  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  removeCommas(ctrl) {
    var result = ctrl.value.toString().replace(/,/g, '');
    ctrl.setValue(result);
  }

  replaceCommas(ctrl) {
    var result = ctrl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    if (result.indexOf('.') < 0) {
      result += ".00";
    }
    ctrl.setValue(result);
  }
  numberRemoveCommas(x) {
    return x.replace(/,/g, '');
  }
  numberWithCommas(x) {
    x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (x.indexOf('.') < 0)
      x += ".00";
    return x
  }

  async loadChannelTypes(auth_token: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelTypeList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      this.ChannelTypeList = response;
    } catch (error) {
      console.error('Error loading channel types:', error);
    }
  }

  async loadChannelMapping(auth_token: string, type: string) {
    try {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        ChannelTypeCode: this.form.get('ProjectSaleChannelTypeCode').value,
        ChannelMappingType: type,
        ChannelMappingFlagActive: "Y"
      };

      const response = await this.httpClient.post<any>(
        this.baseurl + "Channel/GetChannelMappingList",
        JSON.stringify(objectjson),
        httpOptions
      ).toPromise();

      if (type === 'D') {
        this.ChannelMappingDList = response;
      } else {
        this.ChannelMappingCList = response;
      }

      const list = type === 'D' ? this.ChannelMappingDList : this.ChannelMappingCList;
    } catch (error) {
      console.error('Error loading channel mapping:', error);
    }
  }

  async onChannelTypeChange(event: any) {
    const selectedValue = event.target.value;
    const selectedChannel = this.ChannelTypeList.find(x => x.ChannelTypeCode === selectedValue);

    console.log(event)

    var auth_token = await this.TokenService.RefreshToken();

    if (selectedChannel && selectedChannel.ChannelTypeFlagDealer === 'Y') {
      this.isDealerChannel = true;
      await this.loadChannelMapping(auth_token, 'D');
    } else {
      this.isDealerChannel = false;
      await this.loadChannelMapping(auth_token, 'C');
    }
  }

  channelMappingValidator(formGroup: FormGroup) {
    const channelTypeCode = formGroup.get('ProjectSaleChannelTypeCode').value;
    const channelMappingCode = formGroup.get('ProjectSaleChannelMappingCode').value;

    if (channelTypeCode && !channelMappingCode) {
      formGroup.get('ProjectSaleChannelMappingCode').setErrors({ required: true });
    } else {
      formGroup.get('ProjectSaleChannelMappingCode').setErrors(null);
    }

    return null;
  }

  LoadRequestFinished(page: any): void {
    this.currentPageNumber_LeadTransac = page.currentPageNumber;

    this.LoadTansaction(this.hidProjectRequestType, this.hidProjectSaleId).then((data) => {
      this.LeadTransaction = data;
    });
    this.LoadCountTansaction(this.hidProjectRequestType, this.hidProjectSaleId);
  }

  async LoadTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_LeadTransac - 1) * environment.PageSizeSmall;

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      objectjson['rowFetch'] = environment.PageSizeSmall;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<LeadTansactionInfo[]>(this.baseurl + "LeadTansaction/GetLeadTansaction",
          strjson, httpOptions)
        .toPromise().then((data) => {
          return data;
        });
    }
  }

  async LoadCountTansaction(RequestType, ProjectSaleId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LeadTansactionProjectSaleRequestType'] = RequestType;
      objectjson['LeadTansactionProjectSaleId'] = ProjectSaleId;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "LeadTansaction/GetCountLeadTansaction",
          strjson, httpOptions)
        .subscribe(data => {
          this.totalLeadTransaction = data;
          if (this.totalLeadTransaction == 0) this.currentPageNumber_LeadTransac = 0;
          this.totalPages_LeadTransac = Math.ceil(this.totalLeadTransaction / environment.PageSizeSmall);
        });
    }
  }

  ProjectSaleCompGroupChange() {
    const groupCode = this.form.get('ProjectSaleCompanyGroupCode')?.value;

    if (groupCode) {
      this.groupCodeSelected = groupCode;
      this.CompanyList = []; // เคลียร์รายการบริษัทเก่า

      this.filteredCompanyList = []; // **(เพิ่มใหม่)** เคลียร์รายการบริษัทที่ถูกกรองด้วย
      this.form.get('ProjectSaleCompanyId')?.setValue(null); // **(เพิ่มใหม่)** ล้างค่า Company Name ในฟอร์ม
      this.searchCompanyNameText = ''; // **(เพิ่มใหม่)** เคลียร์ข้อความในช่อง Company Name Autocomplete

      // **(แก้ไข)** เรียก loadCompany เมื่อมีการเปลี่ยนแปลง Company Group
      // ตรวจสอบ auth_token ก่อนเรียกใช้ loadCompany
      this.TokenService.RefreshToken().then(auth_token => {
        if (auth_token) {
          this.loadCompany(auth_token, groupCode).then((companyList) => {
            this.CompanyList = companyList;
            this.filteredCompanyList = [...this.CompanyList]; // **(เพิ่มใหม่)** อัปเดต filteredCompanyList ด้วยข้อมูลใหม่
          });
        }
      });
    } else {
      this.groupCodeSelected = null;
      this.CompanyList = [];

      this.filteredCompanyList = []; // **(เพิ่มใหม่)** เคลียร์รายการบริษัทที่ถูกกรองด้วย
      this.form.get('ProjectSaleCompanyId')?.setValue(null); // **(เพิ่มใหม่)** ล้างค่า Company Name ในฟอร์ม
      this.searchCompanyNameText = ''; // **(เพิ่มใหม่)** เคลียร์ข้อความในช่อง Company Name Autocomplete
    }
  }

  async loadSaleRequesterFromOriginatorEnable(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    objectjson['SaleTeamCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleTeamCode'].value);
    //objectjson['FlagIsApprover'] = "N";

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeamRequest", strjson, httpOptions)
      .toPromise()
  }

  async loadAssetTypeList(auth_token: string, type: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const objectjson = {
      AssetCategoryCode: this.form.get('ProjectSaleProductCategoryCode').value,
    };

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<AssetTypeInfo[]>(this.baseurl + "AssetType/GetAssetType", strjson, httpOptions)
      .toPromise()
  }

  async loadAssetCategoryList(auth_token: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<AssetCategoryInfoInfo[]>(this.baseurl + "AssetType/GetAssetCategory", strjson, httpOptions)
      .toPromise()
  }

  async onProductCategoryChange(event: any) {
    this.form.get('ProjectSaleAssetType')?.setValue(null);

    const selectedValue = event.target.value;

    var auth_token = await this.TokenService.RefreshToken();

    if (selectedValue) {
      await this.loadAssetTypeList(auth_token, selectedValue).then((data) => {
        this.AssetTypeList = data;
      }
      );
    }
  }

  projectSaleProductCategoryCodeValidator(formGroup: FormGroup) {
    const AssetCategoryCode = formGroup.get('ProjectSaleProductCategoryCode').value;
    const AssetTypeCode = formGroup.get('ProjectSaleAssetType').value;

    if (AssetCategoryCode && !AssetTypeCode) {
      formGroup.get('ProjectSaleAssetType').setErrors({ required: true });
    } else {
      formGroup.get('ProjectSaleAssetType').setErrors(null);
    }

    return null;
  }

  async onLoadAssetTypeByCategory(categoryCode: string, defaultAssetTypeCode?: string) {
    this.AssetTypeList = [];

    var auth_token = await this.TokenService.RefreshToken();

    if (categoryCode) {
      await this.loadAssetTypeList(auth_token, categoryCode).then((data) => {
        this.AssetTypeList = data;

        if (defaultAssetTypeCode) {
          // ใช้ค่าเดิมที่เคยบันทึกไว้
          this.form.patchValue({ ProjectSaleAssetType: defaultAssetTypeCode });
        } else if (this.AssetTypeList.length > 0) {
          // default เป็น index 0
          this.form.patchValue({
            ProjectSaleAssetType: this.AssetTypeList[0].AssetTypeCode
          });
        }
      });
    }
  }

  onSearchTextChange(value: string): void {
    this.searchText = value; // อัปเดตค่า searchText ด้วยข้อความที่พิมพ์
    this.filterCompanyGroups(); // เรียกใช้ฟังก์ชันกรองข้อมูล
    this.showDropdown = true; // แสดง dropdown ขึ้นมา

    // **สำคัญ:** หากข้อความที่พิมพ์ไม่ตรงกับรายการที่มีอยู่ ให้ล้างค่าใน FormControl
    // เพื่อป้องกันการส่งค่าที่ไม่ถูกต้องไปกับฟอร์ม และเพื่อให้ Validators.required ทำงานได้ถูกต้อง
    if (!this.CompanyGroupList.some(x => `${x.CompanyGroupCode} - ${x.CompanyGroupName}`.toLowerCase().includes(this.searchText.toLowerCase()))) {
      this.form.get('ProjectSaleCompanyGroupCode')?.setValue(null);
    }
  }

  filterCompanyGroups(): void {
  const companyGroups = this.CompanyGroupList || [];
  const search = (this.searchText || '').toLowerCase();

  if (!search) {
    this.filteredCompanyGroupList = [...companyGroups]; // ถ้าไม่มีข้อความค้นหา ให้แสดงทั้งหมด
  } else {
    this.filteredCompanyGroupList = companyGroups.filter(x =>
      (x?.CompanyGroupCode ?? '').toLowerCase().includes(search) ||
      (x?.CompanyGroupName ?? '').toLowerCase().includes(search)
    );
  }
} //ggg


  selectCompanyGroup(companyGroup: CompanyGroupInfo): void { // ใช้ CompanyGroupInfo ตาม model ของคุณ
    this.searchText = `${companyGroup.CompanyGroupCode} - ${companyGroup.CompanyGroupName}`; // แสดงชื่อเต็มใน input
    this.form.get('ProjectSaleCompanyGroupCode')?.setValue(companyGroup.CompanyGroupCode); // ตั้งค่า form control ด้วย code ที่ถูกต้อง
    this.showDropdown = false; // ซ่อน dropdown หลังจากการเลือก
    this.ProjectSaleCompGroupChange(); // **(สำคัญ)** เรียกใช้เมธอด ProjectSaleCompGroupChange เดิมของคุณ

  }

  onInputFocus(): void {
    //this.searchText = '';
    //this.form.get('ProjectSaleCompanyGroupCode')?.setValue(null);
    this.filteredCompanyGroupList = this.CompanyGroupList
    this.showDropdown = true;
    //this.filterCompanyGroups(); // กรองอีกครั้งในกรณีที่ข้อความถูกล้างหรือเปลี่ยนจากภายนอก
  }

  onInputBlur0(): void {
    setTimeout(() => {
      this.showDropdown = false;
    }, 150); // ดีเลย์สั้นๆ (150 มิลลิวินาที)
  }

  onInputBlur(): void {
  setTimeout(() => {
    const match = this.filteredCompanyGroupList.find(x =>
      `${x.CompanyGroupCode} - ${x.CompanyGroupName}`.toLowerCase() === this.searchText.toLowerCase()
    );

    if (!match) {
      // Clear ค่า
      this.searchText = '';
      this.form.get('ProjectSaleCompanyGroupCode')?.setValue(null);
    }

    this.showDropdown = false;
  }, 200);
}

  onSearchCompanyNameTextChange(value: string): void {
    this.searchCompanyNameText = value; // อัปเดตค่า searchCompanyNameText ด้วยข้อความที่พิมพ์
    this.filterCompanies(); // เรียกใช้ฟังก์ชันกรองข้อมูลบริษัท
    this.showCompanyDropdown = true; // แสดง dropdown ขึ้นมา

    // **สำคัญ:** หากข้อความที่พิมพ์ไม่ตรงกับรายการที่มีอยู่ ให้ล้างค่าใน FormControl
    // เพื่อป้องกันการส่งค่าที่ไม่ถูกต้องไปกับฟอร์ม และเพื่อให้ Validators.required ทำงานได้ถูกต้อง
    // เราจะตรวจสอบกับรูปแบบเต็ม: CompanyGroupCode - CompanyCode - CompanyName
    // if (!this.CompanyList.some(x =>
    //   `${x.CompanyGroupCode} - ${x.CompanyCode} - ${x.CompanyName}`.toLowerCase().includes(this.searchCompanyNameText.toLowerCase())
    // )) {
    //   this.form.get('ProjectSaleCompanyId')?.setValue(null);
    // }

    const isMatched = this.CompanyList.some(x =>
      `${x.CompanyGroupCode} - ${x.CompanyCode} - ${x.CompanyName}`.toLowerCase() === this.searchCompanyNameText.toLowerCase()
    );

    // If no match is found, or the input is cleared, clear the form control and contact list
    if (!isMatched && this.searchCompanyNameText !== '') {
      this.form.get('ProjectSaleCompanyId')?.setValue(null);
      this.form.get('ProjectSaleCompanyAbbreviation')?.setValue(null);
      // **New:** Clear CompanyContactList and its form control
      this.CompanyContactList = [];
      this.form.get('SelectCompanyContact')?.setValue(null);
      console.log('Company ID and Contact List cleared because no match found or input changed.');
    } else if (this.searchCompanyNameText === '') {
      // If the input is completely cleared, also clear the form control and contact list
      this.form.get('ProjectSaleCompanyId')?.setValue(null);
      this.form.get('ProjectSaleCompanyAbbreviation')?.setValue(null);
      this.CompanyContactList = [];
      this.form.get('SelectCompanyContact')?.setValue(null);
      console.log('Company ID and Contact List cleared because input is empty.');
    }
  }

  filterCompanies(): void {
  const companies = this.CompanyList || [];
  const search = (this.searchCompanyNameText || '').toLowerCase();

  if (!search) {
    this.filteredCompanyList = [...companies]; // ถ้าไม่มีข้อความค้นหา ให้แสดงทั้งหมด
  } else {
    this.filteredCompanyList = companies.filter(x =>
      (x?.CompanyGroupCode ?? '').toLowerCase().includes(search) ||
      (x?.CompanyCode ?? '').toLowerCase().includes(search) ||
      (x?.CompanyName ?? '').toLowerCase().includes(search) ||
      `${x?.CompanyGroupCode ?? ''} - ${x?.CompanyCode ?? ''} - ${x?.CompanyName ?? ''}`
        .toLowerCase()
        .includes(search)
    );
  }
}

  async selectCompany(company: CompanyInfo): Promise<void> {
    this.searchCompanyNameText = `${company.CompanyGroupCode} - ${company.CompanyCode} - ${company.CompanyName}`;
    this.form.get('ProjectSaleCompanyId')?.setValue(company.CompanyId);
    this.form.get('ProjectSaleCompanyAbbreviation')?.setValue(company.CompanyAbbreviation);
    this.showCompanyDropdown = false;
    // Don't call btnonclick_loadcompany() again because the CompanyId was set

    //console.log('CompanyCode ของบริษัทที่เลือก:', company.CompanyCode);
    this.CompanyContactList = [];
    await this.LoadCompanyContactList(company.CompanyCode).then((data) => {
        this.CompanyContactList = data;

        if (this.CompanyContactList.length > 0) {
          this.form.get('SelectCompanyContact')?.setValue(this.CompanyContactList[0].CompanyContactCode); //
        }
        //console.log("CompanyContactList: ", this.CompanyContactList);
      });
  }

  onCompanyNameInputFocus(): void {
    //this.searchCompanyNameText = '';
    //this.form.get('ProjectSaleCompanyId')?.setValue(null);
    this.filteredCompanyList = this.CompanyList;
    this.showCompanyDropdown = true;
    //this.filterCompanies();
  }

  onCompanyNameInputBlur0(): void {
    setTimeout(() => {
      this.showCompanyDropdown = false;

      const currentCompanyId = this.form.get('ProjectSaleCompanyId')?.value;
      if (currentCompanyId && !this.searchCompanyNameText) { // user delete own
        const selectedCompany = this.CompanyList.find(x => x.CompanyId === currentCompanyId);
        if (selectedCompany) {
          this.searchCompanyNameText = `${selectedCompany.CompanyGroupCode} - ${selectedCompany.CompanyCode} - ${selectedCompany.CompanyName}`;
        }
      } else if (!currentCompanyId && this.searchCompanyNameText) {
        this.searchCompanyNameText = '';
      }
    }, 150); // delay time
  }

  onCompanyNameInputBlur(): void {
    // หน่วงเวลาเล็กน้อยเพื่อให้ mousedown event ของ dropdown-item ทำงานก่อน
    setTimeout(() => {
      this.showCompanyDropdown = false;

      const currentCompanyId = this.form.get('ProjectSaleCompanyId')?.value;
      const selectedCompany = this.CompanyList.find(x => x.CompanyId === currentCompanyId);
      const selectedCompanyNameFull = selectedCompany ? `${selectedCompany.CompanyGroupCode} - ${selectedCompany.CompanyCode} - ${selectedCompany.CompanyName}` : '';

      // **Logic สำหรับเคลียร์ค่าเมื่อไม่ตรงหรือไม่ถูกเลือก**
      // กรณีที่ 1: ไม่มี ProjectSaleCompanyId (ยังไม่ได้เลือก หรือถูกเคลียร์ไปแล้ว)
      // และ searchCompanyNameText ไม่ว่างเปล่า (ผู้ใช้พิมพ์แล้วไม่ได้เลือก)
      // หรือ
      // กรณีที่ 2: มี ProjectSaleCompanyId (เคยเลือกแล้ว)
      // แต่ searchCompanyNameText ไม่ตรงกับชื่อเต็มของบริษัทที่เลือก
      if ((!currentCompanyId && this.searchCompanyNameText !== '') ||
          (currentCompanyId && this.searchCompanyNameText !== selectedCompanyNameFull)) {
        this.searchCompanyNameText = ''; // เคลียร์ข้อความใน input
        this.form.get('ProjectSaleCompanyId')?.setValue(null);
        this.form.get('ProjectSaleCompanyAbbreviation')?.setValue(null);
        this.CompanyContactList = [];
        this.form.get('SelectCompanyContact')?.setValue(null);
        console.log('Company ID and Contact List cleared on blur due to mismatch or unselected text.');
      }
      // กรณีที่ 3: ถ้า ProjectSaleCompanyId มีค่า และ searchCompanyNameText ว่างเปล่า (ผู้ใช้ลบข้อความทั้งหมด)
      // ให้เคลียร์ค่าทั้งหมดเช่นกัน
      else if (currentCompanyId && this.searchCompanyNameText === '') {
        this.form.get('ProjectSaleCompanyId')?.setValue(null);
        this.form.get('ProjectSaleCompanyAbbreviation')?.setValue(null);
        this.CompanyContactList = [];
        this.form.get('SelectCompanyContact')?.setValue(null);
        console.log('Company ID and Contact List cleared on blur because input was emptied.');
      }
      // กรณีอื่น ๆ (เช่น เลือกถูกต้องแล้ว หรือ input ว่างเปล่าตั้งแต่แรก) ไม่ต้องทำอะไร
    }, 150); // delay time
  }

  async LoadCompanyContactList(companycontactCode: string) {
    if (companycontactCode) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['CompanyCode'] = companycontactCode;

        let strjson = JSON.stringify(objectjson);

        return await this.httpClient.post<CompanyContactInfo[]>(this.baseurl + "Company/GetCompanyContact", strjson, httpOptions)
                      .toPromise()

      }
    }
  }

  get isEditMode(): boolean {
  return this._ParamStatus === 'c' || this._ParamStatus === 'u';
}

ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Unsubscribe from all subscriptions
  }
  
}
